module.exports = "pegasus/assets/styleGroup1-pinterest.gif";